import { fetchEB } from '@eb/http';
import { String } from 'aws-sdk/clients/apigateway';
import { FormState as FormStateInterface } from '../context';

const URL = '/ajax/contact-organizer/';

interface ContactOrganizerBody {
    from_name: String;
    from_email: String;
    message: String;
    reason: String;
    captchaResponse?: String;
}

interface OrganizerContactApi {
    formState: FormStateInterface;
    organizerId: String;
    eventId?: String;
    collectionId?: String;
}

const formatForPost = (formState: FormStateInterface): ContactOrganizerBody => {
    return {
        from_name: formState.name.val || '',
        from_email: formState.email.val || '',
        message: formState.message.val || '',
        reason: formState.reason.val || '',
        captchaResponse: formState?.captcha?.val || '',
    };
};

export const postOrganizerContact = async (data: OrganizerContactApi) => {
    const { formState, organizerId, eventId, collectionId } = data;
    let formattedUrl = `${URL}${organizerId}/`;
    if (eventId) {
        formattedUrl = `${formattedUrl}${eventId}/`;
    } else if (collectionId) {
        formattedUrl = `${formattedUrl}collection/${collectionId}/`;
    }
    const formattedPostBody = formatForPost(formState);

    const response = await fetchEB(formattedUrl, {
        method: 'POST',
        body: JSON.stringify(formattedPostBody),
    });

    const json = await response.json();
    return json;
};

/**
 * Get current logged in user
 */
export const getUser = async () => {
    const response = await fetchEB('/api/v3/users/me/');
    const userData = await response.json();
    return userData;
};
